import React from "react"
import { useNavigate } from "react-router-dom"
import { history } from "../../../app/App"
import arrow from '../../../assets/img/shortArrow.svg'


const GoBack = ({ text, nav}) => {
    let navigate = useNavigate()
    const goBack = () => {
        nav ? navigate(nav) : navigate(-1)
    }
    return (
        <div className="content-wrapper" style={{padding: 0}}>
            <div style={{ height: '74px', display: 'flex', alignItems: 'center' }}>
                <div onClick={goBack} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}><img style={{ height: '15px', width: '15px', marginRight: '13px' }} src={arrow} />{text}</div>
            </div>
        </div>
    )
}
export default GoBack
